function extarctHyperautomationLabel(markdownString: string): string | null {
    // Regex to match the text inside the square brackets [label](url)
    const match = markdownString.match(/\[([^\]]+)\]/);

    // Return the captured group if found, otherwise null
    return match ? match[1] : null;
}

export default extarctHyperautomationLabel;
